export const BRAND = "CircularX";
export const CIRX_URL = "https://www.circularx.co/";

// When the web file page is ready, delete this constant
export const ACCESS_TO_WEB_FILE_PAGE_FROM_HOME = false;
